import React, { forwardRef } from 'react';
import ModalDialog from 'rsuite/cjs/Modal/ModalDialog';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';
import { useHeaderMenuContext } from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';

const DrawerDialogContainer = forwardRef((props, ref) => {
  const { width } = useHeaderMenuContext();
  const dialogStyle = {};
  if (width !== null) {
    dialogStyle.maxWidth = width;
  }

  return (
    <ModalDialog
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...props}
      style={dialogStyle}
      ref={ref}
    />
  );
});

DrawerDialogContainer.defaultProps = {
  ...ClassNameDefaultProps,
  ...ChildrenDefaultProps,
};

DrawerDialogContainer.propTypes = {
  ...ClassNamePropTypes,
  ...ChildrenPropTypes,
};

export default DrawerDialogContainer;
